module.exports = `
<div class="col-md-4 col-6">
    <div class="mb-5">
        <div class="info position-relative">
            <div class="hover-img">
	            <a :href="productLink" class="d-inline-block position-relative ">
	    	        <new-image :url="productImg" :size="'_w480_h640'" :name="productName"></new-image>
	    	        <div class="f-mask"></div>
		        </a>
		        <a @click.prevnet="cancelFavorite(data.Colors[0].CustomMarketID)" href="#" class="btn-f-remove">
               		 <i class="icon-close3"></i>
            	</a>
		    </div>
	        <div class="position-relative row mt-4">
	        	<div class="col-md-6 col-12">
	        		<div class="product-name"> <a :href="productLink">{{productName}}({{data.Colors[0].ColorName}})</a></div>
			        <div class="mb-3 h5">
		                <span class="sell-price d-inline-block mx-1">NT.{{eventPrice >0 && eventPrice < sellPrice ?eventPrice: sellPrice}}</span>
		                <span v-if="sellPrice !== originPrice || eventPrice >0" class="origin-price d-inline-block mx-1">NT.{{originPrice}}</span>
		            </div>
	        	</div>
	        	<div class="col-md-6 col-12">
		        	<div class="font-futura2 text-left">            
		            	<a :data-custommarketid="data.Colors[0].CustomMarketID" :data-colorid="data.Colors[0].ColorID" href="#" class="btn btn-outline-primary btn-block btn-lg open-dialog">加入購物車</a>           
		        	</div>
	        	</div>	        	            
	            
	        </div>    	    
            
        </div>
        
    </div>
</div>
`;
